// styling
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './style.module.scss';
// assets
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot } from '@mui/lab';
import { useState } from 'react';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

const OurService = () => {
    const [changeBtn, setChangeBtn] = useState(true);

    const timelineData1 = [
        {
            title: 'Low Cost',
            detail: 'Produce Content At A Fraction Of The Cost',
        },
        {
            title: 'As Needed',
            detail: 'Use Credits Whenever You Want',
        },
        {
            title: 'Produce',
            detail: 'Enjoy The Visual & Personalized Content',
        },
    ];

    const timelineData2 = [
        {
            title: 'Subscribe',
            detail: 'Access Various Specialty Tools & Features At No Extra Cost',
        },
        {
            title: 'Flexibility',
            detail: 'Choose From A Monthly Or Annual Subscription Package',
        },
        {
            title: 'Exclusive',
            detail: 'Receive Monetization Opportunities, Marketing Boosts and More',
        },

    ];

    const payAsYouGo = () => {
        setChangeBtn(true);
    }

    const forSubscribers = () => {
        setChangeBtn(false);
    }

    const timelineData = changeBtn ? timelineData1 : timelineData2;

    return (
        <section className={styles.section}>
            <div className={`${styles.container} container`}>
                <div className="d-flex flex-column g-10">
                    <p className={styles.pPlat}>Our Serivce</p>
                    <p className={styles.pPlatText}>
                        Work Like A <span className={styles.pPlatTextSpan}>Studio</span> Without The Financial Expense
                    </p>
                </div>
                <div className={styles.changeBtn}>
                    <button className={changeBtn ? styles.enableBtn : styles.disableBtn} onClick={payAsYouGo}>Pay As You Go</button>
                    <span>&nbsp;&nbsp;</span>
                    <button className={!changeBtn ? styles.enableBtn : styles.disableBtn} onClick={forSubscribers}>For Subscribers</button>
                </div>
                <Timeline position="alternate-reverse">
                    {timelineData.map((item, index) => (
                        <TimelineItem key={index}>
                            <TimelineSeparator>
                                <TimelineDot />
                                {index !== timelineData.length - 1 && <TimelineConnector />}
                            </TimelineSeparator>
                            <TimelineContent>
                                <div className={styles.timeline}>
                                    <p className={styles.phead}><FontAwesomeIcon
                                        icon={faCircleCheck}
                                        size="sm"
                                    />&nbsp;{item.title}</p>
                                    <p className={styles.pdetail}>{item.detail}</p>
                                </div>
                            </TimelineContent>
                        </TimelineItem>
                    ))}
                </Timeline>
            </div>
        </section>
    )
}

export default OurService